import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Follow = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill={fill}
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <path
        d="M5.973 11c.234 0 .41.194.468.467.118.666.059 1.333-.175 1.933-.41 1-1.288 1.6-2.225 1.6-.996 0-1.932-.667-2.4-1.867-.176-.533-.176-1.133-.06-1.666.06-.267.293-.467.528-.467zm8.096-1c.24 0 .419.09.419.368.04.955-.02 1.632-.18 2.032-.418 1-1.315 1.6-2.272 1.6-1.017 0-1.974-.733-2.393-1.867-.18-.533-.18-1.133-.06-1.666.06-.267.3-.467.539-.467zM4 2c1.74 0 3 1.486 3 3.429 0 .685-.12 1.142-.24 1.657-.18.571-.36 1.2-.36 2.343 0 .342-.24.571-.6.571H2.2c-.3 0-.54-.171-.6-.457C1.6 9.486 1 7.2 1 5.429 1 3.486 2.26 2 4 2zm8-1c1.74 0 3 1.486 3 3.429 0 1.714-.6 4-.6 4.114-.06.286-.3.457-.6.457h-3.6c-.36 0-.6-.229-.6-.571 0-1.143-.18-1.772-.36-2.343C9.12 5.57 9 5.114 9 4.429 9 2.486 10.26 1 12 1z"
        transform="translate(-1452 -1035) translate(1452 1035)"
      />
    </svg>
  );
};

Follow.displayName = 'Follow';
